import { gql } from "@apollo/client";

export const GET_BUYERS = gql`
query getBuyers($pageOptions: PageOptions,$filters: [BuyerFilters], $sortOptions: [SortOptions]) {
    getBuyers(pageOptions: $pageOptions, filters: $filters, sortOptions: $sortOptions) {
        buyer{
        arcimedes_row_id
        status
        agent
        agent_firm
        first_name
        last_name
        company_name
        company_address
        company_city
        company_state
        company_zip
        phone
        email
        category
        type
        single_tenant_subcategory
        multi_tenant_subcategory
        market
        price_min
        price_max
        cap_rate_min
        cap_rate_max
        strive_agent
        strive_agent_last_name
        cell_phone
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
        }
        totalCount
    }
}
`

export const GET_BUYERS_BY_ID = gql`
query getBuyerById($arcimedes_row_id: ID!){
    getBuyer(arcimedes_row_id: $arcimedes_row_id){
        arcimedes_row_id
        status
        agent
        agent_firm
        first_name
        last_name
        company_name
        company_address
        company_city
        company_state
        company_zip
        phone
        email
        notes
        profile
        category
        type
        single_tenant_subcategory
        multi_tenant_subcategory
        market
        price_min
        price_max
        cap_rate_min
        cap_rate_max
        strive_agent
        strive_agent_last_name
        cell_phone
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
    }
}
`

export const GET_TEAM = gql`
query getBuyerTeamMembers($arcimedes_row_id: ID){
    getBuyerTeamMembers(arcimedes_row_id: $arcimedes_row_id){
            first_name
            last_name
    }
}
`